import classNames from "classnames";
import Img, { ImgProps } from "components/img/img";
import ModalImage from "components/modal/modalImage";
import { graphql } from "gatsby";
import React, { useState } from "react";
import "./image.scss";
import parse from "html-react-parser";

export interface ImageProps {
  alt?: string;
  caption?: string;
  align?: string;
  localFile: {
    childImageSharp?: {
      gatsbyImageData: {
        images: {
          fallback: {
            src: string;
            srcSet: string;
            sizes: string;
          }
        }
      }
    };
    publicURL: string;
  };
}

interface Props extends ImageProps {}

const Image: React.FC<Props> = (props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleImageClick = () => {
    if (props.align !== "center") {
      setModalOpen(true);
    }
  };

  return (
    <>
      <figure
        className={classNames("image", {
          "is-smaller": props.align === "center",
        })}
        onClick={handleImageClick}
      >
        {!!props.alt && <div className="image__title">{parse(props.alt)}</div>}
        <Img localFile={ props.localFile } altText={props.alt} />
        {!!props.caption && <figcaption>{parse(props.caption)}</figcaption>}
      </figure>
      {!!modalOpen && <ModalImage onClose={handleModalClose} {...props} />}
    </>
  );
};

export default Image;

export const query = graphql`
  fragment ImageBlock on WpCoreImageBlock {
    attributes {
      ... on WpCoreImageBlockAttributes {
        alt
        caption
        align
        localFile: imageFile {
          childImageSharp {
            gatsbyImageData(width: 1600, quality: 80)
          }
          publicURL
        }
      }
    }
  }
`;
